import React, { useEffect, useState } from "react";
import styles from "./home.module.css";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../Component/Header/Header";
import { Helmet } from "react-helmet";
import { GET_FORMS } from "../../APIs/BaseUrl";
import Moment from "react-moment";
import Notification from "../../Component/Notification/Notification";
import Page from "../../Component/Pagination/Page";
import { useAuth } from "../../Context/AuthContext";

const Forms = () => {
  const navigate = useNavigate();
  const { toggleNotification } = useAuth();

  const [forms, setForms] = useState([]);
  const [error, setError] = useState(null);

  const [page, setPage] = useState(1);
// eslint-disable-next-line
  const [limit, setLimit] = useState(10);

  const [pagination, setPagination] = useState({
    totalDocs: 0,
    limit: limit,
    totalPages: 1,
    page: 1,
  });

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${GET_FORMS}?limit=${limit}&page=${page}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch forms");
        const data = await response.json();
        setForms(data?.data.docs);
        setPagination({
          totalDocs: data?.data.totalDocs,
          limit: data?.data.limit,
          totalPages: data?.data.totalPages,
          page: data?.data.page,
        });
      } catch (err) {
        setError(err.message);
      }
    };
    fetchForms();
  }, [page, limit]);

  return (
    <React.Fragment>
      <div className="right-aside">
        <Helmet>Forms</Helmet>
        <Row>
          <Col md={!toggleNotification ? 12 : 8} sm={12}>
            <Header />
            <div className={styles.head_sec}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Forms</h6>
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => navigate("/forms/create")}
                >
                  Create Form
                </button>
              </div>
              {error && <div className="text-danger">{error}</div>}
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Form Name</th>
                      <th>Created At</th>
                      <th>Questions Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {forms && forms.length > 0 ? (
                      forms.map((form, index) => (
                        <tr key={form._id}>
                          <td>{index + 1}</td>
                          <td style={{whiteSpace : "nowrap"}}>{form.form_name ?? "----"}</td>
                          <td style={{whiteSpace : "nowrap"}}>
                            <Moment format="YYYY-MM-DD HH:mm">
                              {form.createdAt}
                            </Moment>
                          </td>
                          <td style={{whiteSpace : "nowrap"}}>{form.questions?.length || 0}</td>
                          <td style={{whiteSpace : "nowrap"}}>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                navigate(`/forms/edit/${form._id}`)
                              }
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">
                          No forms found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end">
                  <Page {...pagination} onPageChange={setPage} />
                </div>
              </div>
            </div>
          </Col>
          {toggleNotification && <Col md={4} sm={12}>
            <Notification />
          </Col>}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Forms;
